import React from "react";

const UnLock = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M5 31.333A2.666 2.666 0 0 0 7.668 34H29a2.666 2.666 0 0 0 2.667-2.667V18A2.666 2.666 0 0 0 29 15.334H13v-4.667a5.332 5.332 0 0 1 5.334-5.333 5.332 5.332 0 0 1 5.333 5.333V11A1.667 1.667 0 0 0 27 11v-.333A8.666 8.666 0 0 0 18.334 2a8.666 8.666 0 0 0-8.667 8.667v4.667h-2A2.666 2.666 0 0 0 5 18v13.333Zm10.667-8.666a2.666 2.666 0 1 1 4.113 2.24s.26 1.573.553 3.427c0 .553-.446 1-1 1h-2c-.553 0-1-.447-1-1l.554-3.427a2.663 2.663 0 0 1-1.22-2.24Z"
              fill={fill}/>
    </svg>
);

export default UnLock;